import React, { PropTypes } from "react";
import classNames from "classnames";

class HistoryNavigator extends React.Component {
  render() {
    const backClassNames = classNames({
      back: true,
      icon: true,
      "icon-chevron-small-left": true,
    });
    const setForwardClassNames = classNames({
      forward: true,
      icon: true,
      "icon-chevron-small-right": true,
    });
    return (
      <div className="history-navigator">
        <div
          className={backClassNames}
          onClick={() => {
            this.context.router.goBack();
          }}
        />
        <div
          className={setForwardClassNames}
          onClick={() => {
            this.context.router.goForward();
          }}
        />
      </div>
    );
  }
}

HistoryNavigator.contextTypes = {
  router: PropTypes.object,
};

export default HistoryNavigator;



// WEBPACK FOOTER //
// ./src/components/common/HistoryNavigator.js